import React from 'react';
import { clp } from '../../utils/cotizadorEngine';

export default function TablaDocumentos({
  documentos,
  reglas,
  deudorLoadingIdx,
  onUpdate,
  onBuscarDeudor,
  onAdd,
  onRemove,
}) {
  const opcionesClasif = reglas.map((r) => [r.clasificacion, `${r.clasificacion} — ${r.banda_pricing}`]);

  return (
    <div className="space-y-3">
      <div className="overflow-x-auto rounded-xl border border-slate-200">
        <table className="w-full min-w-[900px] text-left text-sm">
          <thead className="bg-slate-100">
            <tr>
              <th className="p-2">Folio</th>
              <th className="p-2">RUT deudor</th>
              <th className="p-2">Clasif.</th>
              <th className="p-2">Monto factura</th>
              <th className="p-2">Anticipo</th>
              <th className="p-2">Plazo</th>
              <th className="p-2 w-28" />
            </tr>
          </thead>
          <tbody>
            {documentos.map((doc, idx) => (
              <tr key={idx} className="border-t border-slate-100 align-top">
                <td className="p-2">
                  <input
                    className="w-full rounded-lg border px-2 py-1"
                    value={doc.folio || ''}
                    onChange={(e) => onUpdate(idx, 'folio', e.target.value)}
                    placeholder="Nº factura"
                  />
                </td>
                <td className="p-2">
                  <input
                    className="w-full rounded-lg border px-2 py-1"
                    value={doc.rut_deudor || ''}
                    onChange={(e) => onUpdate(idx, 'rut_deudor', e.target.value)}
                    placeholder="12345678-9"
                  />
                  <button
                    type="button"
                    onClick={() => onBuscarDeudor(idx)}
                    disabled={deudorLoadingIdx === idx || !doc.rut_deudor?.trim()}
                    className="mt-1 w-full rounded-lg bg-slate-600 py-1 text-xs font-semibold text-white disabled:opacity-50"
                  >
                    {deudorLoadingIdx === idx ? '...' : 'Buscar'}
                  </button>
                </td>
                <td className="p-2">
                  <select
                    className="w-full rounded-lg border px-2 py-1"
                    value={doc.clasificacion_aplicada || ''}
                    onChange={(e) => {
                      onUpdate(idx, 'clasificacion_aplicada', e.target.value);
                      onUpdate(idx, 'clasificacion_manual', true);
                    }}
                  >
                    <option value="">—</option>
                    {opcionesClasif.map(([v, lbl]) => (
                      <option key={v} value={v}>{lbl}</option>
                    ))}
                  </select>
                </td>
                <td className="p-2">
                  <input
                    type="number"
                    className="w-full rounded-lg border px-2 py-1"
                    value={doc.monto_factura || 0}
                    onChange={(e) => onUpdate(idx, 'monto_factura', Number(e.target.value))}
                  />
                </td>
                <td className="p-2">
                  <input
                    type="number"
                    className="w-full rounded-lg border px-2 py-1"
                    value={doc.monto_operacion || 0}
                    onChange={(e) => onUpdate(idx, 'monto_operacion', Number(e.target.value))}
                  />
                </td>
                <td className="p-2">
                  <input
                    type="number"
                    className="w-full rounded-lg border px-2 py-1"
                    value={doc.plazo || 0}
                    onChange={(e) => onUpdate(idx, 'plazo', Number(e.target.value))}
                  />
                </td>
                <td className="p-2">
                  {documentos.length > 1 && (
                    <button
                      type="button"
                      onClick={() => onRemove(idx)}
                      className="w-full rounded-lg border border-red-200 py-1 text-xs font-semibold text-red-600 hover:bg-red-50"
                    >
                      Quitar
                    </button>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <button
        type="button"
        onClick={onAdd}
        className="w-full rounded-xl border-2 border-dashed border-slate-300 py-2 text-sm font-semibold text-slate-600 hover:border-blue-400 hover:text-blue-600"
      >
        + Agregar factura
      </button>
    </div>
  );
}

export function TablaLineasResumen({ lineas }) {
  if (!lineas?.length) return null;
  return (
    <div className="overflow-x-auto rounded-xl border border-slate-200">
      <table className="w-full text-sm text-left">
        <thead className="bg-slate-100">
          <tr>
            <th className="p-2 whitespace-nowrap">Factura</th>
            <th className="p-2 whitespace-nowrap">Clasif.</th>
            <th className="p-2 whitespace-nowrap">RUT deudor</th>
            <th className="p-2 text-right whitespace-nowrap">Interés</th>
            <th className="p-2 text-right whitespace-nowrap">Comisión</th>
            <th className="p-2 text-right whitespace-nowrap">Gastos</th>
          </tr>
        </thead>
        <tbody>
          {lineas.map((l, i) => (
            <tr key={i} className="border-t border-slate-100">
              <td className="p-2">{l.folio || `Línea ${i + 1}`}</td>
              <td className="p-2">{l.clasificacion_aplicada || '—'}</td>
              <td className="p-2 text-slate-600">{l.rut_deudor || '—'}</td>
              <td className="p-2 text-right tabular-nums">{clp(l.real?.interes)}</td>
              <td className="p-2 text-right tabular-nums">{clp(l.real?.comision)}</td>
              <td className="p-2 text-right tabular-nums">{clp(l.real?.gastos)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
